import * as React from 'react';

export const NotificationContext = React.createContext();

export default function useNotification() {

  const context = React.useContext(NotificationContext);

  if (!context) {
    throw new Error('useNotification must be used within an NotificationProvider');
  }

  const [notification, setNotification] = context;

  return {
    notification,
    setNotification
  }
}